import API from 'shared/connectors/config';

export function searchItems(params) {
  return API.get(`/search?searchParams=${params}`);
}
